const DEFAULT = 'DEFAULT';
const VARIANT = 'VARIANT';
export const PersonalizationVariantStatuses = {
  DEFAULT,
  VARIANT
};
export const StrategyTypes = {
  SMART_PAGE: 'SMART_PAGE',
  ABM: 'ABM'
};